// client/constants/fileExtensions.js
/**
 * Zentrale Datei-Extension-Config für Frontend
 * Synchronisiert mit Backend (utils/constants.js)
 * 
 * ⚠️ WICHTIG: Diese Liste muss mit Backend ALLOWED_FILE_EXTENSIONS synchron bleiben!
 */

// Erlaubte Datei-Extensions (ohne Punkt, lowercase)
export const ALLOWED_FILE_EXTENSIONS = new Set([
  // Doku & Bilder
  "pdf", "jpg", "jpeg", "png", "webp", "heic", "gif",
  // Office
  "doc", "docx", "xls", "xlsx", "csv", "ppt", "pptx",
  // Archive
  "zip", "rar", "7z",
  // Mail/Kalender/Kontakte
  "msg", "eml", "emlx", "ics", "vcf",
  // Text
  "txt",
]);

/**
 * Prüft ob Datei-Extension erlaubt ist
 * @param {string} filename - Dateiname
 * @returns {boolean} - true wenn erlaubt
 */
export function isAllowedExtension(filename = "") {
  const parts = String(filename).toLowerCase().split(".");
  const ext = parts.length > 1 ? parts.pop() : "";
  return ext && ALLOWED_FILE_EXTENSIONS.has(ext);
}

/**
 * Extrahiert Extension aus Dateiname
 * @param {string} filename - Dateiname
 * @returns {string} - Extension ohne Punkt (z.B. "pdf")
 */
export function extractExtension(filename = "") {
  const parts = String(filename).toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
}

/**
 * Frontend-kompatible Extension-Liste für accept-Attribute
 * @returns {string} - Komma-separierte Liste (z.B. ".pdf,.jpg,.png")
 */
export function getAllowedExtensionsForAccept() {
  return Array.from(ALLOWED_FILE_EXTENSIONS)
    .map(ext => `.${ext}`)
    .join(",");
}

/**
 * Frontend-kompatible Extension-Liste für accept-Attribute mit Wildcards
 * @returns {string} - Komma-separierte Liste mit MIME-Types (z.B. "image/*,application/pdf")
 */
export function getAllowedExtensionsForAcceptWithMime() {
  const imageExts = ["jpg", "jpeg", "png", "webp", "gif", "heic"];
  const pdfExts = ["pdf"];
  
  const hasImages = imageExts.some(ext => ALLOWED_FILE_EXTENSIONS.has(ext));
  const hasPdf = pdfExts.some(ext => ALLOWED_FILE_EXTENSIONS.has(ext));
  
  const parts = [];
  if (hasImages) parts.push("image/*");
  if (hasPdf) parts.push("application/pdf");
  
  // Restliche Extensions
  const rest = Array.from(ALLOWED_FILE_EXTENSIONS)
    .filter(ext => !imageExts.includes(ext) && !pdfExts.includes(ext))
    .map(ext => `.${ext}`);
  
  return [...parts, ...rest].join(",");
}
